import { Input, Directive } from '@angular/core';
import { LocLabel } from '../../clickable-row-table/models/data-table-config.models';

@Directive({ selector: 'legacyLabel' })
export class LegacyLabel {
  /** @deprecated use labelKey */
  @Input() public label: string | undefined;
  @Input() public labelKey: string | LocLabel | null | undefined;

  public get labelValue(): string | LocLabel | null {
    return this.labelKey ?? this.label ?? null;
  }
}
